export const getErrorCodeNumber = (state) => state.modalState.errorCodeNumber;

export const getRealTimeErrorCodeNumber = (state) => state.modalState.actualErrorCodeNumber;
